
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"disableAutoPopup":"Diesen Hinweis zukünftig nicht mehr automatisch anzeigen."},"en":{"disableAutoPopup":"Do not display this message again."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();